<template>
  <p
    v-if="authState && authState.blocked"
    role="status"
    class="px-6 py-3 text-sm text-red-500"
    data-cy="x-connection-warning"
  >
    X actions are paused because your account connection could not be verified. Sign out and sign
    back in with this X account to reconnect. Check any failed scheduled posts before retrying them.
  </p>
</template>
<script>
  export default { props: { authState: { type: Object, default: null } } };
</script>
